import { Upload } from 'antd';
import styled from 'styled-components';

const { Dragger } = Upload;
export const DraggerWrapper = styled(Dragger)`
  .ant-upload {
    .ant-upload-btn {
      background-color: var(--light-link);
      padding: 16px;
    }
  }

  .upload-container {
    gap: 15px !important;

    .custom-btn.download-sample-btn {
      background-color: transparent;
      color: var(--link);

      &:hover {
        background-color: var(--light-link);
        color: var(--link);
      }
    }
  }
`;
